import $ from "jquery";

const calculateReadTime = () => {
    const $article = $("#article-content");
    const $readTimeDiv = $("#read-time");

    if ($article.length) {
        const wordCount = $article.html().split(" ").length;
        const cjkCharacterCount =
            $article
                .text()
                .match(/[\u1100-\u11ff\u3040-\u30ff\u3130-\u318f\u3400-\u4dbf\u4e00-\u9fff\uac00-\ud7af\uf900-\ufaff]/g)
                ?.length ?? 0;
        const readTime = Math.ceil(wordCount / 260 + cjkCharacterCount / 500);
        const readTimeLabel =
            readTime === 1
                ? window.i18n["DigitalPresence.ArticlePage.ReadingTime.Singular"] || "Reading time: {0} minute"
                : window.i18n["DigitalPresence.ArticlePage.ReadingTime.Plural"] || "Reading time: {0} minutes";
        $readTimeDiv.text(readTimeLabel.replace("{0}", readTime.toString()));
    }
};

$(function () {
    calculateReadTime();
});
